import { RoleListPage, RoleEditPage, RoleCreatePage } from './imports';

export const roleRoutes = [
  {
    path: 'roles',
    children: [
      {
        element: <RoleListPage />,
        index: true,
      },
      {
        path: 'list',
        element: <RoleListPage />,
      },
      {
        path: ':id/edit',
        element: <RoleEditPage />,
      },
      {
        path: 'new',
        element: <RoleCreatePage />,
      },
    ],
  },
];
